import { useState } from 'react';
import '../styles/Home.css';

const KiteFest = () => {

  return (




    <div className="container">

      <div>
        <h2 class="center-align"><b>Kite Fest 2025</b></h2>
      </div>

      <div><hr class="hr-line"></hr></div>

      <div>
        <h4 class="center-align c-gray"><span class="c-blue">When:</span> Saturday July 19th, 2025, 11:00 am - 6:00 pm CST</h4>
      </div>

      <div>
        <h4 class="center-align c-gray"><span class="c-blue">Cost:</span> <b>FREE</b> for All.</h4>
      </div>

      <div>
        <h4 class="center-align c-gray"><span class="c-blue">Location:</span> Grove Elementary School, Airport Rd, Normal IL 61761</h4>
      </div>

      <p >&nbsp;&nbsp;</p>
      <div>
        <h4 class="center-align c-gray"><b >For a Better Tomorrow presents Kite Fest, an annual fundraising event benefiting local and global communities. This will be our 12th year in a row since starting in 2014. Kite Fest 2025 will be held on Saturday, July 19, 2025 at Grove Elementary School.</b></h4>
      </div>

      <div className="row">

        <div className="col-md-4">

          <div className="div-img-text">

            <img src="/images/base/BlueSquare.png" alt="" width="100%" className="rounded-circle"></img>
            <div className="text-on-image">

              <p >&nbsp;</p>
              <h3 ><b >Talent Show</b></h3>
              <p >&nbsp;</p>
              <h4 className="cFFFFFF"><i ><a href="https://tinyurl.com/KiteFest2025"><b><span className="cFFFFFF">Registration Form</span></b></a></i></h4>
              <h5 >Deadline is July 13th</h5>
            </div>

          </div>

        </div>

        <div className="col-md-4">

          <div className="div-img-text">

            <img src="/images/base/BlueSquare.png" alt="" width="100%" className="rounded-circle"></img>
            <div className="text-on-image">

              <p >&nbsp;</p>
              <h3 ><b >STEAM Race</b></h3>
              <p >&nbsp;</p>
              <h4 className="cFFFFFF"><i ><a href="https://docs.google.com/forms/d/e/1FAIpQLSdOEWfqo4WplIpWSyMmm6v7XV4lZ1lNToLQ_M_-IX4LUTNHRw/viewform?usp=preview "><b><span className="cFFFFFF">Registration Form</span></b></a></i></h4>
              <h5 >Early bird offer ends 6/30</h5>
              <h5 ></h5>
            </div>

          </div>

        </div>

        <div className="col-md-4">

          <div className="div-img-text">

            <img src="/images/base/BlueSquare.png" alt="" width="100%" className="rounded-circle"></img>
            <div className="text-on-image">

              <p >&nbsp;</p>
              <h3 ><b >Fun Games</b></h3>
              <p >&nbsp;</p>
              <h4 className="cFFFFFF"><i >More details soon</i></h4>
              <h5 ></h5>
            </div>

          </div>

        </div>

      </div>

      <p >&nbsp;&nbsp;</p>
      <div>
        <h2 class="center-align"><b ></b></h2>
        <p class="center-align"><img src="/images/flyers/KiteFest2025.jpg" alt="" width="100%" className="rounded" /></p>
        <div><hr class="hr-line"></hr></div>

        <h2 class="fbt-tag-line"> Our mission is to promote social justice by meeting needs in the local community and the world through accountable, sustainable philanthropy and by nurturing future generations of servant leaders. </h2>
      </div>

    </div>



  );
}
export default KiteFest;
